import {TisaProduct} from '../tisa-product';

export type ProductsUrls = Record<TisaProduct, string>;
